import React from 'react'
import styled from 'styled-components'

const TextFieldWrapperElement = styled.div`
  position: relative;
`

const InputElement = styled.input`
  width: ${(props) => props.width || '100%'};
  padding: 10px;
  border: 1px solid ${(props) => (props.error ? 'red' : '#ccc')} !important;
  border-radius: 4px;
  outline: none;
  font-size: 0.8rem;
  transition: border-color 0.3s;
  color: #4b5563;

  &::placeholder {
    font-style: italic;
  }

  &:focus {
    border-color: ${(props) => (props.error ? 'red' : '#2e8ab8')} !important;
    box-shadow: 0px 0px 2px
      ${(props) => (props.error ? 'red' : 'rgba(46, 138, 184, 0.75)')} !important;
  }

  &:focus + label,
  &:not(:placeholder-shown) + label {
    top: 3px;
    font-size: 10px;
  }

  &:focus + label {
    color: ${(props) => (props.error ? 'red' : '#2e8ab8')};
  }

  &:disabled {
    background-color: #f8f8f8;
    color: #bbbbbd !important;
  }
`

const LabelElement = styled.label`
  color: #9a9a9c;
  position: absolute;
  top: 50%;
  left: 6px;
  transform: translateY(-50%);
  background: white;
  padding: 0 4px;
  transition: top 0.3s, font-size 0.3s, color 0.3s;
  pointer-events: none;
  font-size: 0.7rem;
  margin-bottom: 0 !important;
`

const TextField = React.forwardRef(
  ({ label, helperText, ...restOfProps }, ref) => {
    return (
      <TextFieldWrapperElement>
        <InputElement
          innerRef={ref}
          type="text"
          placeholder=""
          {...restOfProps}
        />
        <LabelElement>{label}</LabelElement>
      </TextFieldWrapperElement>
    )
  }
)

export default TextField
